
  console.log('ready 123');
  
  // update selector to corresponding cart menu
  //$('.header__action-item-content').on('click', function() {
  $("body").on("click", ".site-header__cart", function(e) {
    e.preventDefault();
    showMiniCart();
  });
  
  $("body").on("click", ".closeMiniCart, #miniCartOverlay", function(){
    closeMiniCart();
  });
  
  $('#shopify-section-mini-cart').on('mouseleave', function() {
    //$(this).hide();
  });
  $("body").on("click", "#mini-cart .minus1", function(e){
    e.preventDefault();
    e.stopPropagation();
    var pid = $(this).data("pid");
    minusCart($(this), pid);
  });
  $("body").on("click", "#mini-cart .plus1", function(e){
    e.preventDefault();
    e.stopPropagation();
    var pid = $(this).data("pid");
    plusCart($(this), pid);
  });
  $("body").on("click", ".main-top .remove", function(){
    var pid = $(this).data("pid");
    removeProduct(pid);
  });
  
  
  $("form.product-form").on("submit", function(e){
    e.preventDefault();
    addProduct($(this));
    
  });
  
  
  
  
  function addProduct(_this) {
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: _this.serialize(),
      async: false,
      success: function(){
       	              showMiniCart();
          }
    });
  }
  
  function showMiniCart() {
    
      
      $.getJSON('/cart.js', function(data) {
        console.log(data);

        // run template view
        var template = $("#minicart-template").html();
        var tmpl = _.template(template);

        // populate cart data
        $("#mini-cart").html(tmpl({cart:data}));

        // format all prices
        $('.price', '#mini-cart').each(function() {
          $(this).html( Shopify.formatMoney($(this).text()) );
          //$(this).html( $(this).text() );
        });
        $(".subTotalText").text(Shopify.formatMoney($(".subTotalText").text()));

        // format image to small
        $('img', '#mini-cart').each(function() {
          var src = $(this).attr('src');
          src = src.replace('.jpg', '_100x100.jpg'); // if using jpg
          src = src.replace('.jpeg', '_100x100.jpeg'); // if using jpeg
          $(this).attr('src', src);
        });
        $("#miniCartOverlay").addClass("open");
		$("#shopify-section-mini-cart").addClass("active");
        //$('#mini-cart').show();
        
      });
    
      
    
  }
  
  function closeMiniCart() {
    $("#miniCartOverlay").removeClass("open");
    $("#shopify-section-mini-cart").removeClass("active");
    
  }
  
  
  function plusCart(_this, pid) {
    var itemQty = parseInt(_this.prev("#itemQty").val());
    itemQty = itemQty + 1;
    
    $.ajax({
      method: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data:
      { 
        quantity: itemQty,
       	id: pid
      },
      success: function(){
        showMiniCart();
      }
    });
    
    //_this.prev("#itemQty").val(itemQty);
    
  }
  function minusCart(_this, pid) {
    var itemQty = parseInt(_this.next("#itemQty").val());
    if(itemQty > 0) {
    itemQty = itemQty - 1;
      	$.ajax({
          method: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data:
          { 
            quantity: itemQty,
            id: pid
          },
          success: function(){
            showMiniCart();
          }
          });
          //_this.next("#itemQty").val(itemQty);
      
    }
  }
  
  function removeProduct(pid) {
    $.ajax({
      method: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data:
      { 
        quantity: 0,
       	id: pid
      },
      success: function(){
        showMiniCart();
      }
    });
  }
  
